import { getAxiosApiInstanceByName } from '@gcl/react-core';
import { Axios, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AXIOS_API_SERVER } from './constants';
import { endXhrAction, startXhrAction } from './dynatrace.services';

export const apiServerGet: Axios['get'] = <T = any, R = AxiosResponse<T>, D = any>(
  url: string,
  config?: AxiosRequestConfig<D>,
): Promise<R> => {
  const actionId = startXhrAction(url);
  return getAxiosApiInstanceByName(AXIOS_API_SERVER)
    .get<T, R, D>(url, config)
    .finally(() => {
      endXhrAction(actionId ?? 0);
    });
};
export const apiServerPost: Axios['post'] = <T = any, R = AxiosResponse<T>, D = any>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>,
): Promise<R> => {
  const actionId = startXhrAction(url);
  return getAxiosApiInstanceByName(AXIOS_API_SERVER)
    .post<T, R, D>(url, data, config)
    .finally(() => {
      endXhrAction(actionId ?? 0);
    });
};
export const apiServerPut: Axios['put'] = <T = any, R = AxiosResponse<T>, D = any>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>,
): Promise<R> => {
  const actionId = startXhrAction(url);
  return getAxiosApiInstanceByName(AXIOS_API_SERVER)
    .put<T, R, D>(url, data, config)
    .finally(() => {
      endXhrAction(actionId ?? 0);
    });
};
export const apiServerDelete: Axios['delete'] = <T = any, R = AxiosResponse<T>, D = any>(
  url: string,
  config?: AxiosRequestConfig<D>,
): Promise<R> => {
  const actionId = startXhrAction(url);
  return getAxiosApiInstanceByName(AXIOS_API_SERVER)
    .delete<T, R, D>(url, config)
    .finally(() => {
      endXhrAction(actionId ?? 0);
    });
};
